import { useNavigate } from 'react-router';
import { GridColDef, GridRowParams } from '@mui/x-data-grid';

import { DataGrid, DataGridCard } from '@barboxx/admin-components';
import { ID_WIDTH, NAME_MIN_WIDTH } from '@barboxx/admin-utils';
import { Category, CategoryAssignment } from '@barboxx/models';

const columns: GridColDef<CategoryAssignment>[] = [
    {
        field: 'id',
        headerName: 'Id',
        width: ID_WIDTH,
    },
    {
        field: 'name',
        headerName: 'Name',
        minWidth: NAME_MIN_WIDTH,
        flex: 1,
        valueGetter: (value, row, column, ref) => {
            switch (row.type) {
                case 'StandardDrink':
                    return row?.standardDrink?.name;
                case 'CustomDrink':
                    return row?.customDrink?.name;
                case 'Product':
                    return row?.product?.name;
            }
        },
    },

    {
        field: 'type',
        headerName: 'Type',
        minWidth: NAME_MIN_WIDTH,
    },
];

interface Props {
    category: Category.DetailsResponse;
    refetch: () => void;
}

export const CategoryAssignmentListCard = ({ category, refetch }: Props) => {
    const { assignments } = category;
    const navigate = useNavigate();

    const handleRowClick = (params: GridRowParams) => {
        navigate(`/menu/${params.id}`);
    };

    return (
        <DataGridCard title="Assigned Items List">
            <DataGrid
                columns={columns}
                disableColumnMenu
                disableRowSelectionOnClick
                paginationMode="client"
                onRowClick={handleRowClick}
                rows={assignments}
            />
        </DataGridCard>
    );
};
